// extracted by mini-css-extract-plugin
module.exports = {"systemMsg":"style_systemMsg__2WtqT","msg":"style_msg__3hoYe","close_btn":"style_close_btn__1nqPT"};